import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { GroupContainer } from '../../../../../../../components/HotelDetailsOverlay/components/AmadeusRatingSection/components/RatingGroups/components/GroupContainer.js';
import { Skeleton, Stack } from '../../../../../../../primitives/index.js';
import { SPACING_SMALL, SPACING_XSMALL } from '../../../../../../../utils/spacingLegacy.js';
export const RatingGroupsLoadingState = () => {
  return _jsx(GroupContainer, {
    children: Array.from({
      length: 12
    }).fill('').map((_, index) => _jsxs(Stack, {
      spacing: SPACING_XSMALL,
      children: [_jsx(Skeleton, {
        variant: "text",
        width: "50%",
        height: 24
      }), _jsxs(Stack, {
        direction: "row",
        spacing: SPACING_SMALL,
        children: [_jsx(Skeleton, {
          variant: "text",
          width: 25
        }), _jsx(Skeleton, {
          variant: "text"
        })]
      })]
    }, index))
  });
};